<template>
  <BaseCard :title="'POVO Class Registration Interface'" :highlightLastWord="false">
    <div class="flex flex-col justify-center gap-4">
      <div class="w-full grid lg:grid-cols-2 lg:gap-20">
        <h5 class="lg:justify-self-end lg:pr-6 font-medium">Project Leader</h5>
        <h5 class="lg:justify-self-start lg:pl-6 font-medium">January 2025 - January 2026</h5>
      </div>

      <p class="text-center items-center px-4 gap-2">
        <span class="block">Revamped Notre Dame's PATH & NOVO class registration systems into one combined interface</span>
        <span class="block">Developed through 4 sprints of user research, sketches/prototypes, Figma design, & Vue.js reactive prototype</span>
        <span class="block">Led a team of 3 focused on HCI Principles</span>
        <span class="block">Collaborated with PhD Students & HCI faculty to engage with the ND Registrar</span>
        <span class="block">Visit the 
          <a href="https://povo-interface-online.web.app/" target="_blank" class="link-in-text">prototype</a>
          or read our
          <a href="https://docs.google.com/document/d/1FWvtfMxiwoWXePhVTn7zi39D3eHltyPQMtqWOpfCSvA/edit?usp=sharing" target="_blank" class="link-in-text">Design Document</a>
          for more details!
        </span>
      </p>
      <span class="flex flex-col place-items-center overflow-hidden">
        <img class="w-[50%] h-auto rounded-lg cursor-pointer" :src="PovoPrototype" @click="openImageMenu(PovoPrototype, 'POVO Interface', $event.currentTarget)">
      </span>
    </div>
  </BaseCard>
</template>

<script lang="ts" setup>
import BaseCard from '@/features/global/BaseCard.vue';
import PovoPrototype from '@/assets/Projects/PovoPhotos/PovoPrototype.jpg';
import { useImageViewer } from '@/features/composables/useImageViewer';

const { openImageMenu } = useImageViewer();
</script>